import { Pipe, PipeTransform } from '@angular/core';

import { pessoaTermoLGPDStatuses } from '../pessoa-termo-lgpd-status';

@Pipe({
    name: 'pessoaTermoLGPDStatusBadge'
})
export class PessoaTermoLGPDStatusBadgePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = pessoaTermoLGPDStatuses.findIndex(status => status.id === value);
        if (index > -1) {
            return pessoaTermoLGPDStatuses[index].badge;
        }
        return '';
    }
}
